import React, { useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { sanitizeKey } from '../utils/engagementKeys';
import './PredictionPoints.css';

/**
 * 🔮 Prediction points earned by a verified dancer in "Predict Winner".
 * Shows exactly what they predicted. Renders nothing until the dancer has settled predictions.
 */
export default function PredictionPoints({ dancerName }) {
  const [stats, setStats] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!dancerName) return undefined;
    let cancelled = false;
    getDoc(doc(db, 'dancerPredictionStats', sanitizeKey(dancerName)))
      .then((snap) => { if (!cancelled) setStats(snap.exists() ? snap.data() : null); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [dancerName]);

  if (!stats || !stats.total) return null;

  const byEvent = new Map();
  (stats.history || []).forEach((h) => {
    if (!byEvent.has(h.eventId)) byEvent.set(h.eventId, { name: h.competitionName, items: [] });
    byEvent.get(h.eventId).items.push(h);
  });

  return (
    <div className="pp-card">
      <button className="pp-head" onClick={() => setOpen((v) => !v)} aria-expanded={open}>
        <span className="pp-title">🔮 Prediction Points</span>
        <span className="pp-points">{stats.points}</span>
        <span className="pp-sub">{stats.points} correct of {stats.total} predictions</span>
        <span className="pp-chevron">{open ? '▲' : '▼'}</span>
      </button>
      {open && (
        <div className="pp-body">
          {[...byEvent.entries()].map(([eventId, ev]) => (
            <div key={eventId} className="pp-event">
              <div className="pp-event-name">{ev.name}</div>
              <ul>
                {ev.items.map((h) => (
                  <li key={`${eventId}-${h.categoryId}`} className={h.correct ? 'ok' : 'miss'}>
                    <span className="pp-mark">{h.correct ? '✅' : '❌'}</span>
                    <span className="pp-cat">{h.categoryLabel}</span>
                    <span className="pp-detail">
                      predicted <strong>{h.picked}</strong>
                      {!h.correct && <> — winner: {h.winner}</>}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
